import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "-my-3.5" }
const _hoisted_2 = {
  key: 0,
  class: "rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800"
}
const _hoisted_3 = { class: "-my-3.5" }
const _hoisted_4 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_5 = { class: "text-sm text-gray-500" }
const _hoisted_6 = { class: "-my-3.5 divide-y divide-[#eef0f3]" }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-wrap items-end gap-3"
}
const _hoisted_8 = { class: "flex flex-wrap gap-2" }

import { computed } from 'vue'

import InputArea from '@/components/neue/InputArea.vue'
import InputField from '@/components/neue/InputField.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import AmountField from '@/components/neue/wizard/AmountField.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { CREDIT_REWARD, newReward, REWARD_TYPES, rewardLabel } from '@/config/membershipTierWizardPass'
import { BILLING_INTERVALS, GRANT_DAYS, passCopy, tierLabel } from '@/config/membershipTierWizardSteps'


export default {
  __name: 'StepPass',
  props: { currency: { type: String, default: 'USD' } },
  setup(__props) {

const EXPIRY_UNITS = [
  { name: 'days', value: 'day' },
  { name: 'weeks', value: 'week' },
  { name: 'months', value: 'month' },
  { name: 'years', value: 'year' }
]
const AMOUNT_TYPES = ['ImmediateMembershipPassReward', CREDIT_REWARD]



const wizard = injectWizard()
const pass = computed(() => wizard.data.pass)
const passName = computed(() => pass.value.name.trim() || 'the pass')
const linkLabel = computed(() => `Offer ${passName.value} with ${tierLabel(wizard.data)}`)

const sharedNote = computed(() => {
  const others = (wizard.meta?.value?.pass_shared_tier_count ?? 0) - 1
  if (others < 1) return ''
  const memberships = others === 1 ? '1 other membership' : `${others} other memberships`
  return `${passName.value} is shared with ${memberships}. Changes here apply to every one of them.`
})

const rewardTitle = reward => REWARD_TYPES.find(type => type.value === reward.type)?.title ?? 'Other reward'
const hasAmount = reward => AMOUNT_TYPES.includes(reward.type)

const setInterval = (reward, interval) => {
  reward.interval = interval
  if (interval === 'monthly') {
    reward.awardDay = null
    reward.awardDate = reward.awardDate ?? 1
  } else {
    reward.awardDate = null
    reward.awardDay = reward.awardDay ?? 'monday'
  }
}

const setExpires = (reward, expires) => {
  reward.expiryType = expires ? 'week' : null
  reward.expiryValue = expires ? 1 : null
}

const addReward = type => {
  pass.value.rewards = [...pass.value.rewards, newReward(type)]
}

const removeReward = index => {
  pass.value.rewards = pass.value.rewards.filter((_, i) => i !== index)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(passCopy)('passLink', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ToggleRow, {
            modelValue: pass.value.linked,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((pass.value.linked) = $event)),
            title: linkLabel.value
          }, null, 8, ["modelValue", "title"])
        ])
      ]),
      _: 1
    }, 16),
    (pass.value.linked)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(passCopy)('passDetails', _unref(wizard).data))), {
            default: _withCtx(() => [
              (sharedNote.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                    _createVNode(_unref(HighlightedText), { text: sharedNote.value }, null, 8, ["text"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(InputField, {
                modelValue: pass.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((pass.value.name) = $event)),
                name: "Pass name"
              }, null, 8, ["modelValue"]),
              _createVNode(InputArea, {
                modelValue: pass.value.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((pass.value.description) = $event)),
                name: "Pass description",
                rows: "3"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 16),
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(passCopy)('passBilling', _unref(wizard).data))), {
            default: _withCtx(() => [
              _createVNode(AmountField, {
                modelValue: pass.value.priceCents,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((pass.value.priceCents) = $event)),
                kind: "money",
                name: "Pass price"
              }, null, 8, ["modelValue"]),
              _createVNode(PillRadioGroup, {
                modelValue: pass.value.billingInterval,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((pass.value.billingInterval) = $event)),
                options: _unref(BILLING_INTERVALS),
                label: "Billed"
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(ToggleRow, {
                  modelValue: pass.value.autoSelect,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((pass.value.autoSelect) = $event)),
                  title: "Pick the pass for customers at checkout",
                  description: "Checkout ticks the pass for customers who can add the pass. They can untick the pass."
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 16),
          _createVNode(WizardSection, _mergeProps(_unref(passCopy)('passRewards', _unref(wizard).data), { plain: "" }), {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pass.value.rewards, (reward, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  "data-reward": "",
                  class: "space-y-4 rounded-xl border border-gray-200 bg-white p-5"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(rewardTitle(reward)), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(rewardLabel)(reward, __props.currency)), 1)
                  ]),
                  (hasAmount(reward))
                    ? (_openBlock(), _createBlock(AmountField, {
                        key: 0,
                        modelValue: reward.amountCents,
                        "onUpdate:modelValue": $event => ((reward.amountCents) = $event),
                        kind: "money",
                        name: "Amount"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (reward.type === _unref(CREDIT_REWARD))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(PillRadioGroup, {
                          "model-value": reward.interval,
                          options: _unref(BILLING_INTERVALS),
                          label: "Credit given",
                          "onUpdate:modelValue": $event => (setInterval(reward, $event))
                        }, null, 8, ["model-value", "options", "onUpdate:modelValue"]),
                        (reward.interval === 'monthly')
                          ? (_openBlock(), _createBlock(AmountField, {
                              key: 0,
                              modelValue: reward.awardDate,
                              "onUpdate:modelValue": $event => ((reward.awardDate) = $event),
                              kind: "integer",
                              name: "Day of the month"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          : (_openBlock(), _createBlock(SelectInput, {
                              key: 1,
                              "model-value": reward.awardDay,
                              name: "Credit day",
                              options: _unref(GRANT_DAYS),
                              "onUpdate:modelValue": $event => (reward.awardDay = $event)
                            }, null, 8, ["model-value", "options", "onUpdate:modelValue"])),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(ToggleRow, {
                            modelValue: reward.autoApply,
                            "onUpdate:modelValue": $event => ((reward.autoApply) = $event),
                            title: "Apply the credit at checkout automatically"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(ToggleRow, {
                            "model-value": reward.expiryType !== null,
                            title: "Unused credit expires",
                            "onUpdate:modelValue": $event => (setExpires(reward, $event))
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ]),
                        (reward.expiryType !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(AmountField, {
                                modelValue: reward.expiryValue,
                                "onUpdate:modelValue": $event => ((reward.expiryValue) = $event),
                                kind: "integer",
                                name: "Expires after"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(PillRadioGroup, {
                                modelValue: reward.expiryType,
                                "onUpdate:modelValue": $event => ((reward.expiryType) = $event),
                                options: EXPIRY_UNITS,
                                label: "Expiry unit"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(WizardButton, {
                    onClick: $event => (removeReward(index))
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Remove", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(REWARD_TYPES), (type) => {
                  return (_openBlock(), _createBlock(WizardButton, {
                    key: type.value,
                    onClick: $event => (addReward(type.value))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Add " + _toDisplayString(type.title.charAt(0).toLowerCase() + type.title.slice(1)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ])
            ]),
            _: 1
          }, 16)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

}